import React from 'react';
import TituloViguetaWpc from '../components/sections/ViguetaWpc/TituloViguetaWpc';
import IntroViguetaWpc from '../components/sections/ViguetaWpc/IntroViguetaWpc';
import DescripcionViguetaWpc from '../components/sections/ViguetaWpc/DescripcionViguetaWpc';
import AplicacionesViguetaWpc from '../components/sections/ViguetaWpc/AplicacionesViguetaWpc';
import FormularioContactoViguetaWpc from '../components/sections/ViguetaWpc/FormularioContactoViguetaWpc';
import VigasPVCSector from '../components/sections/VigasPVCSector';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';  

const ViguetaWpcPage = () => {
  return (
    <div>
      <Header />
        <TituloViguetaWpc />  
        <IntroViguetaWpc />   
        <DescripcionViguetaWpc /> 
        <AplicacionesViguetaWpc /> 
        <VigasPVCSector />
        <FormularioContactoViguetaWpc />  
      <Footer />  
    </div>
  );
};

export default ViguetaWpcPage;